<template>
	<div>
		<sBox title="Grade de Tipos de Vacina">
			<!-- <div slot='tools'>


				<div class="box-excel-export">

					<aBtn
						action='private-save-tipos_de_vacina2'
						@click='$refs.modalExcel.open()'
						text='Importar Excel' icon='plus' size='sm' type='info'
						class="btn-export"
					/>



					<aBtn
							@click='handleConvertTableToXLS()'
							text='Exportar Excel' icon='minus' size='sm' type='info'
							class="btn-import"
						/>
			</div>
			</div> -->
			<div slot="body">
				<br />
				<sBox title="Filtrar Tipos de Vacina">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>id</span>
							<input
								v-model="filter.id"
								@input="fxFilter('id', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="ID"
							/>
						</div>
						<div class="col-md-3">
							<span>Vacina</span>
							<input
								v-model="filter.nome_tipo_vacina"
								@input="
									fxFilter(
										'nome_tipo_vacina',
										$event.target.value
									)
								"
								type="text"
								class="form-control"
								placeholder="VACINA"
							/>
						</div>
					</div>
				</sBox>

				<br />
				<!-- action='private-save-tipos_de_vacina2'	 -->
				<!-- @click='this.handleConvertTableToXLS()' -->
				<div class="box-excel-export">
					<aBtn
						action="private-save-tipos_de_vacina"
						@click="$refs.modal.open()"
						text="Tipos de Vacina"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-tipos_de_vacina"
					actionDelete="private-delete-tipos_de_vacina"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="
						(data) => {
							$refs.modal.open(data);
						}
					"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroTiposdeVacina',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'id', label: 'ID' },
					{ data: 'nome_tipo_vacina', label: 'Vacina' },
				],
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]

				filter: {
					id: '',
					nome_tipo_vacina: '',
				},
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.id != '')
					f.push(`id like '%${this.filter.id}%'`);

				if (this.filter.nome_tipo_vacina != '')
					f.push(
						`nome_tipo_vacina like '%${this.filter.nome_tipo_vacina}%'`
					);

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados dos Tipos de Vacina.xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Tipos de Vacina', '']);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/tipos_de_vacina/index.vue